export function errMsg(err) {
    if (typeof err === 'string' || err instanceof String)
        return err;
    else if (err.constructor.name === 'StateError')
        return err['message'];
    else if (err.constructor.name === 'StateError' && '$thrownJsError' in err)
        return errMsg(err['$thrownJsError']);
    else if (err instanceof Error)
        return err.message;
    else
        return err.toString();
}
export function errStack(err) {
    if (err instanceof Error)
        return err.stack;
    else if (err.constructor.name === 'StateError' && '$thrownJsError' in err)
        return errStack(err['$thrownJsError']);
    return undefined;
}
export function errInfo(err) {
    return [errMsg(err), errStack(err)];
}
//# sourceMappingURL=err-info.js.map